export default __webpack_public_path__ + "5a1d5c62d27b419fbd61f46ccb6cfda3.png";